import {
  REQUEST_DONATION_CATEGORY_LIST_WITH_CHILDREN
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestDonationCategoryListWithChildren({commit}) {
    return axiosInst.springAxiosInst.get('/api/donation-category/get-all-categories', {
    }).then((res) => {
      commit(REQUEST_DONATION_CATEGORY_LIST_WITH_CHILDREN, res.data)
    })
  }
}